import { FirebaseConfig } from './remote-config'

export default function isSseWhitelisted(firebaseConfig: FirebaseConfig, athlinksEventId: number) {
  const raw = firebaseConfig.config.useSseEventWhitelist?.asString() ?? ''
  const whitelistedEvents = raw.split(',').map(x => +x).filter(y => !!y)

  return !whitelistedEvents.length || whitelistedEvents.includes(athlinksEventId)
}